import { render, staticRenderFns } from "./ModalProfileItemSelector.vue?vue&type=template&id=6623833c&scoped=true"
import script from "./ModalProfileItemSelector.vue?vue&type=script&lang=js"
export * from "./ModalProfileItemSelector.vue?vue&type=script&lang=js"
import style0 from "./ModalProfileItemSelector.vue?vue&type=style&index=0&id=6623833c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6623833c",
  null
  
)

export default component.exports